import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { AppFacade } from '../../facades/app.facade';

const API_URL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(private _appFacade: AppFacade) {}

  public handleError(error: HttpErrorResponse, req?: HttpRequest<any>) {
    const { status } = error;
    const isUnathorized = status === CONST.HTTP_CODES.UNAUTHORIZED;
    const backendMessage = this._getErrorMessage(error);
    const isUncontrolledError =
      error.status === CONST.HTTP_CODES.INTERNAL_SERVER || error.status === CONST.HTTP_CODES.ERROR;
    const isNotFound = status === CONST.HTTP_CODES.NOT_FOUND;

    if (isUnathorized) return this._appFacade.showSnackBar(CONST.MESSAGES.SESSION_FINISHED);
    if (isUncontrolledError) return this._appFacade.showSnackBar(CONST.MESSAGES.ERROR);
    if (isNotFound) return this._appFacade.showSnackBar(CONST.MESSAGES.ERROR_NOT_FOUND_RESOURCE);

    return this._appFacade.showSnackBar(backendMessage);
  }

  private _getErrorMessage(err: HttpErrorResponse): string {
    const { error } = err;
    if (!error) return '';

    const firstError = Object.keys(error)[0];
    const typeError = typeof error[firstError];
    const isStringError = typeError === 'string';

    if (!isStringError && typeError === 'object') {
      return this._getErrorMessage(error[firstError][0]);
    }
    return error[firstError];
  }
}
